import React, { FC } from 'react';
import { ToggleButton, ToggleButtonProps } from '../ToggleButton';
import { useTranslations } from '@lang';

type SelectToggleButtonProps = Omit<ToggleButtonProps, 'children' | 'isSelected'> & {
  input: { onChange: (value: boolean) => void; value: boolean };
  isDisabled: boolean;
};

export const SelectToggleButton: FC<SelectToggleButtonProps> = ({
  input: { onChange, value },
  isDisabled,
  ...props
}) => {
  const { t } = useTranslations();

  return (
    <ToggleButton
      {...props}
      isDisabled={isDisabled}
      isSmall
      selectedText={t('spa.toggle.deselect')}
      isSelected={value}
      onClick={() => {
        onChange(!value);
      }}
    >
      {t('spa.toggle.select')}
    </ToggleButton>
  );
};
